import { render } from "./ListOpenTrips.vue?vue&type=template&id=525bffcd&scoped=true"
import script from "./ListOpenTrips.vue?vue&type=script&lang=js"
export * from "./ListOpenTrips.vue?vue&type=script&lang=js"

import "./ListOpenTrips.vue?vue&type=style&index=0&id=525bffcd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525bffcd"]])

export default __exports__